export const SYSTEM_NOTIFICATION_PREFERENCES_KEY = 'wegic-system-notification-preferences:v2';

export const INITIAL_GENERATION_NOTIFICATION_TASKS_KEY = 'wegic-initial-generation-notification-tasks:v2';

export const SYSTEM_NOTIFICATION_PREFERENCE_CHANGED_EVENT = 'wegic:system-notification-preference-changed';

export const INITIAL_GENERATION_NOTIFICATION_MAX_HANDLED_PROJECTS = 200;

export const INITIAL_GENERATION_NOTIFICATION_MAX_ARMED_PROJECTS = 20;

export const INITIAL_GENERATION_NOTIFICATION_ARMED_TASK_TTL_MS = 2 * 60 * 60 * 1000;

export const WEGIC_NOTIFICATION_ICON_URL = 'https://cdn.wegic.ai/static/logo.svg';

export const INITIAL_GENERATION_NOTIFICATION_TAG_PREFIX = 'wegic-initial-generation';

export enum SystemNotificationSkipReason {
  Unsupported = 'unsupported',
  AlreadyPrompted = 'already_prompted',
  PermissionNotDefault = 'permission_not_default',
  PermissionNotGranted = 'permission_not_granted',
  MissingPayload = 'missing_payload',
  NotArmed = 'not_armed',
  DuplicateRuntime = 'duplicate_runtime',
  DuplicateProject = 'duplicate_project',
  Foreground = 'foreground',
}

export interface InitialGenerationNotificationPayload {
  projectId: string;
  sessionId?: string;
  messageId: string;
  timestamp?: number;
}

export interface SystemNotificationInstance {
  onclick?: ((event?: Event) => void) | null;
  close?: () => void;
}

export interface SystemNotificationConstructor {
  permission: NotificationPermission;
  requestPermission?: () => Promise<NotificationPermission>;
  new (title: string, options?: NotificationOptions): SystemNotificationInstance;
}

export interface StorageLike {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}
